
import { IImage } from '@/types/models';
import { defineComponent } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/images';

interface IForm {
  keyword: string;
  currentPage: number;
  offset: number;
  limit: number;
}

interface IState {
  images: IImage[];
  count: number;
  formInline: IForm;
}

export default defineComponent({
  data() {
    return {
      images: [],
      count: 0,
      formInline: {
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: 16,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.images = res.images;
        this.count = res.count;
      });
    },

    apiDelete(id: number) {
      api.delete(id, (res) => {
        if (!res) return;

        this.apiGet();
      });
    },

    getSmallUrl(image: IImage) {
      return `https://images.sscms.com/${image.smallUrl}`;
    },

    getRegularUrl(image: IImage) {
      return `https://images.sscms.com/${image.regularUrl}`;
    },

    btnDeleteClick(image: IImage) {
      utils.alertDelete(
        {
          title: `删除图片${image.imageId}`,
          text: '此操作将会删除图片，确定吗？',
          button: '删 除',
        },
        () => {
          this.apiDelete(image.id);
        },
      );
    },

    btnLogView(logId: number) {
      utils.pageOpen('error', {
        logId,
      });
    },

    btnSearchClick() {
      this.formInline.currentPage = 1;
      this.formInline.offset = 0;

      api.get(this.formInline, (res) => {
        this.images = res.images;
        this.count = res.count;
      });
    },

    btnDownloadClick() {
      api.download((res) => {
        if (!res) return;

        utils.success('下载完毕！');
        this.handleCurrentChange(1);
      });
    },

    onError(image: IImage) {
      console.log(image.id);
    },

    btnCheckClick() {
      api.check((res) => {
        if (!res) return;

        utils.success('审查完毕！');
        this.handleCurrentChange(1);
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      api.get(this.formInline, (res) => {
        this.images = res.images;
        this.count = res.count;
        utils.scrollTop();
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
